import { DefaultTheme } from 'styled-components';

/**
 * Primary theme styling
 */
export const primary: DefaultTheme = {
  baseURL: process.env.PUBLIC_URL
};
